module.exports = __webpack_public_path__ + "ethereum-buyBlue.svg?5864262d9945ec716fed48babfbfaefa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ethereum-buyBlue.svg
// module id = 835
// module chunks = 2